import { useAuthStore, useNotificationSettingsStore } from 'src/common/store'
import { onSignalREvent } from '../../signalRBus'
import { useNotificationStore, useOrgStore } from 'src/stores'
import { SIGNAL_R_MESSAGES, SIGNAL_R_SCOPES } from 'src/signalR/types'
import {
  MEDICATION_PAST_DUE_SOUND_SETTING,
  NotificationSoundKey,
  NotificationType,
} from 'src/interfaces/notificationPreferences'
import { NotificationPriority } from 'src/interfaces/notification'
import { showCrossCenterNotification } from 'src/utils/notificationActions'
import { playNotificationSound } from 'src/utils/notificationSounds'

function parseNotificationType(value?: string): NotificationType | undefined {
  const normalizedValue = value?.toLowerCase()

  return Object.values(NotificationType).find(
    (notificationType) => notificationType.toLowerCase() === normalizedValue,
  )
}

function parseNotificationPriority(
  value?: string,
): NotificationPriority | undefined {
  const normalizedValue = value?.toLowerCase()

  return Object.values(NotificationPriority).find(
    (priority) => priority.toLowerCase() === normalizedValue,
  )
}

onSignalREvent(
  SIGNAL_R_SCOPES.notification,
  SIGNAL_R_MESSAGES.newNotification,
  (text) => {
    const [
      notificationTypeText,
      notificationCenterId,
      notificationPriorityText,
    ] = text.split('_', 4)
    const authStore = useAuthStore()
    if (authStore.isSuperAdmin) return
    const notificationStore = useNotificationStore()
    const notificationSettingsStore = useNotificationSettingsStore()
    const orgStore = useOrgStore()
    const notificationType = parseNotificationType(notificationTypeText)
    const notificationPriority = parseNotificationPriority(
      notificationPriorityText,
    )

    if (!notificationType) return

    if (notificationType === NotificationType.Message) return

    const isTypeEnabled = notificationSettingsStore.isInAppEnabledForCenter(
      notificationType,
      notificationCenterId,
    )

    if (!isTypeEnabled) return

    const isSameCenter =
      !notificationCenterId ||
      notificationCenterId === authStore.currentCenterId

    if (isSameCenter) {
      notificationStore.handleNotificationReceived()
      if (
        notificationType === NotificationType.Medication &&
        notificationPriority === NotificationPriority.Critical &&
        notificationSettingsStore.isNotificationSoundEnabled(
          MEDICATION_PAST_DUE_SOUND_SETTING.key,
          MEDICATION_PAST_DUE_SOUND_SETTING.platformKeys,
          MEDICATION_PAST_DUE_SOUND_SETTING.defaultEnabled,
        )
      ) {
        void playNotificationSound(NotificationSoundKey.CriticalAlert)
      }
    } else {
      const isCrossCenterEnabled =
        notificationSettingsStore.isPushEnabledForCenter(notificationCenterId)

      if (isCrossCenterEnabled) {
        const center = orgStore.centers.find(
          (c) => c.id === notificationCenterId,
        )
        const centerName = center?.name || 'another center'

        showCrossCenterNotification(notificationCenterId, centerName)
      }
    }
  },
)
